import { Stack, styled } from 'components/base';

export const StyledStack = styled(Stack)({
  padding: '8px 24px',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: 'white',
  flexDirection: 'row',
});
